import { render, staticRenderFns } from "./PaymentsHistory.vue?vue&type=template&id=7ec72c23&scoped=true&"
import script from "./PaymentsHistory.vue?vue&type=script&lang=js&"
export * from "./PaymentsHistory.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsHistory.vue?vue&type=style&index=0&id=7ec72c23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec72c23",
  null
  
)

export default component.exports